/* Wag & Whisker — theme JS */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Header scroll state ---------- */
  var header = $('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Scroll reveal ---------- */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initReveals(root) {
    var els = $$('.reveal, .reveal-stagger', root || document);
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }
  initReveals();

  /* ---------- Drawers & overlay ---------- */
  var overlay = $('[data-overlay]');
  var openDrawer = null;
  function setOverlay(show) {
    if (!overlay) return;
    if (show) {
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    } else {
      overlay.classList.remove('is-open');
      setTimeout(function () { overlay.hidden = true; }, 400);
    }
  }
  function drawerOpen(id) {
    var d = document.getElementById(id);
    if (!d) return;
    if (openDrawer && openDrawer !== d) openDrawer.classList.remove('is-open');
    d.classList.add('is-open');
    openDrawer = d;
    setOverlay(true);
    document.body.style.overflow = 'hidden';
    var focusable = d.querySelector('button, a, input');
    if (focusable) focusable.focus();
  }
  function drawerClose() {
    if (openDrawer) openDrawer.classList.remove('is-open');
    openDrawer = null;
    setOverlay(false);
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      drawerOpen(opener.getAttribute('data-drawer-open'));
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); drawerClose(); }
  });
  if (overlay) overlay.addEventListener('click', drawerClose);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawerClose(); });

  /* ---------- Quantity inputs (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-plus], [data-qty-minus]');
    if (!btn) return;
    var wrap = btn.closest('.qty-input');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = btn.hasAttribute('data-qty-plus') ? v + 1 : Math.max(1, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart API ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }

  function refreshCartDrawer(openAfter) {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=cart-drawer' : '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('#cart-drawer');
          var current = document.getElementById('cart-drawer');
          if (fresh && current) {
            var wasOpen = current.classList.contains('is-open');
            current.innerHTML = fresh.innerHTML;
            if (wasOpen) current.classList.add('is-open');
          }
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (openAfter) drawerOpen('cart-drawer');
        return cart;
      });
  }

  function addToCart(body, btn) {
    if (btn) { btn.setAttribute('disabled', ''); }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { return refreshCartDrawer(true); })
      .then(function () {
        if (btn) {
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
        }
      })
      .catch(function (err) {
        var msg = (err && err.description) || 'Could not add to cart';
        alert(msg);
      })
      .finally(function () { if (btn) btn.removeAttribute('disabled'); });
  }

  /* product form submit */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('input[name="id"], select[name="id"]');
    var qty = form.querySelector('input[name="quantity"]');
    addToCart(
      { id: parseInt(id.value, 10), quantity: qty ? parseInt(qty.value, 10) || 1 : 1 },
      form.querySelector('[type="submit"]')
    );
  });

  /* quick add */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart({ id: parseInt(btn.getAttribute('data-quick-add'), 10), quantity: 1 }, btn);
  });

  /* cart line changes (drawer + page) */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-line-key'), parseInt(input.value, 10) || 0);
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (!rm) return;
    e.preventDefault();
    changeLine(rm.getAttribute('data-line-key'), 0);
  });
  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          refreshCartDrawer(false);
        }
      });
  }

  /* ---------- Product page ---------- */
  $$('[data-product-wrapper]').forEach(function (wrap) {
    var jsonEl = wrap.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var form = wrap.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var priceEl = wrap.querySelector('[data-price]');
    var atcBtn = form && form.querySelector('[type="submit"]');
    var mainImg = wrap.querySelector('[data-main-image]');

    function money(cents) {
      return (window.WW && window.WW.moneyFormat || '${{amount}}')
        .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    }

    function currentOptions() {
      var opts = [];
      $$('.option-group', wrap).forEach(function (g) {
        var checked = g.querySelector('input:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function onOptionChange() {
      var opts = currentOptions();
      if (!opts.length) return;
      var variant = findVariant(opts);
      $$('.option-group', wrap).forEach(function (g) {
        var label = g.querySelector('[data-selected-value]');
        var checked = g.querySelector('input:checked');
        if (label && checked) label.textContent = checked.value;
      });
      if (!variant) {
        if (atcBtn) { atcBtn.setAttribute('disabled', ''); atcBtn.querySelector('.atc-text').textContent = window.WW.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html = '<span class="price-sale">' + money(variant.price) + '</span><s class="price-compare">' + money(variant.compare_at_price) + '</s>';
        } else {
          html = '<span>' + money(variant.price) + '</span>';
        }
        priceEl.innerHTML = html;
      }
      if (atcBtn) {
        if (variant.available) {
          atcBtn.removeAttribute('disabled');
          atcBtn.querySelector('.atc-text').textContent = window.WW.strings.addToCart;
        } else {
          atcBtn.setAttribute('disabled', '');
          atcBtn.querySelector('.atc-text').textContent = window.WW.strings.soldOut;
        }
      }
      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image.src;
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url.toString());
      }
    }
    wrap.addEventListener('change', function (e) {
      if (e.target.matches('.option-values input')) onOptionChange();
    });

    /* gallery */
    $$('.gallery-thumbs button', wrap).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.style.opacity = 0;
        setTimeout(function () {
          mainImg.src = b.getAttribute('data-full');
          mainImg.style.opacity = 1;
        }, 180);
        $$('.gallery-thumbs button', wrap).forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
      });
    });

    /* sticky mobile ATC */
    var sticky = wrap.querySelector('.sticky-atc');
    var anchor = wrap.querySelector('.qty-and-atc');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(anchor);
      var stickyBtn = sticky.querySelector('[data-sticky-atc]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form) form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  });

  /* ---------- Collection: sort + filters ---------- */
  var sortSelect = $('[data-sort-by]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
  var filterForm = $('form[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', function () {
      filterForm.submit();
    });
  }
})();
